// action types for document types
export const SET_DOCUMENTTYPES_DATA = "SET_DOCUMENTTYPES_DATA";
export const ADD_DOCUMENTTYPE = "ADD_DOCUMENTTYPE";
export const UPDATE_DOCUMENTTYPE = "UPDATE_DOCUMENTTYPE";
export const DELETE_DOCUMENTTYPE = "DELETE_DOCUMENTTYPE";
